import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import useHelpLink from '../useHelpLink';

import style from './PublicContent.scss';

const cn = bemCssModules(style, 'PublicContent');
const ti = getTestId('PublicContent');

enum TranslationsEnum {
  signin = 'signin',
  products = 'products',
  blog = 'blog',
  help = 'help',
  widget = 'widget',
  wallet = 'wallet',
  crypto_in_out = 'crypto_in_out',
  fiat_in_out = 'fiat_in_out',
}

const mainLinks = [
  { key: TranslationsEnum.products, url: 'https://mercuryo.io/products' },
  { key: TranslationsEnum.blog, url: 'https://mercuryo.io/explore' },
] as const;

type OtherLinks = readonly {
  key: TranslationsEnum;
  url: string;
  soon?: boolean;
  disabled?: boolean;
}[];

const otherLinks: OtherLinks = [
  { key: TranslationsEnum.widget, url: '/widget' },
  { key: TranslationsEnum.crypto_in_out, url: '/crypto-in-out' },
  { key: TranslationsEnum.fiat_in_out, url: '/fiat-in-out' },
  { key: TranslationsEnum.wallet, url: '/wallet' },
] as const;

const PublicContent: CustomFC = ({ className }) => {
  const { t } = useTranslation();

  const helpLink = useHelpLink();

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('links')}>
        {mainLinks.map(({ key, url }) => (
          <a
            className={cn('main-link', ['link'])}
            key={key}
            href={url}
            data-testid={ti(`${key}-link`)}
            target="_blank"
            rel="noreferrer"
          >
            {t(`header.${key}`)}
          </a>
        ))}
        <a
          className={cn('main-link', ['link'])}
          data-testid={ti('help-link')}
          href={helpLink}
          target="_blank"
          rel="noreferrer"
        >
          {t('header.help')}
        </a>
      </div>
      <div className={cn('links', { other: true })}>
        {otherLinks.map(({ key, url, soon, disabled }) => (
          <a
            className={cn('other-link', { disabled }, ['link'])}
            key={key}
            data-testid={ti(`${key}-link`)}
            href={`https://mercuryo.io${url}`}
            target="_blank"
            rel="noreferrer"
          >
            {soon && <span className={cn('soon')}>{t('header.soon')}</span>}
            {t(`header.${key}`)}
          </a>
        ))}
      </div>
    </div>
  );
};

export default PublicContent;
